var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "my-4"
  }, [!_vm.hideTitle ? _c('v-list-item', {
    staticClass: "simple title",
    class: (_vm.isValid ? _vm.color : 'error') + '--text',
    staticStyle: {
      "z-index": "2"
    },
    attrs: {
      "aria-expanded": String(_vm.show),
      "disabled": _vm.disabled
    },
    on: {
      "click": function ($event) {
        _vm.$emit('input', _vm.show ? _vm.value.filter(function (x) {
          return x != _vm.title;
        }) : _vm.multiple ? [].concat(_vm.value, [_vm.title]) : [_vm.title]);
      }
    }
  }, [_vm.loading ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "24",
      "width": "2"
    }
  }) : _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.icon)
    }
  }), _c('div', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "margin-left": "0 !important"
    }
  }, [_vm._t("title", function () {
    return [_vm._v(_vm._s(_vm.title))];
  }), !_vm.disabled ? _c('v-icon', {
    staticClass: "menu-down",
    staticStyle: {
      "vertical-align": "top"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMenuDown)
    }
  }) : _vm._e()], 2)], 1) : _vm._e(), _c('v-expand-transition', [_c('v-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show && !_vm.loading,
      expression: "show && !loading"
    }],
    ref: "form",
    class: {
      offset: _vm.offset
    },
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: _vm.isValid,
      callback: function ($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('div', {
    staticClass: "pt-3 pb-6",
    staticStyle: {
      "z-index": "1"
    }
  }, [_vm._t("default")], 2)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }